import * as React from 'react'
import { Box, Paper, TableContainer, Table, TableRow, TableHead, TableCell, TableBody, TextField, MenuItem, Typography } from '@material-ui/core'
import { useQuery } from 'react-query'
import { listInitialInterviews, listCoach, allocInitialInterviewCoach } from '../../utils/api'
import moment from 'moment'
import { DateTimePicker } from '@material-ui/pickers'
import { useTableStyles, StyledTableCell } from '../../components/CustomTable'

const ConsultingContentMap: { [key: string]: string } = {
    'A': '亲子关系及孩子教育问题',
    'B': '婚姻关系及家庭关系问题',
    'C': '我个人的心理、情绪或者执行力问题',
    'D': '我被诊断或怀疑我是成人ADHD',
    'E': '我孩子确诊是ADHD（多动症）',
    'F': '我怀疑我孩子是ADHD（多动症）'
}

const InitialInterview = () => {
    const tableClasses = useTableStyles()

    const [status, setStatus] = React.useState('waitAlloc')
    const { data, refetch } = useQuery<{ list: InitialInterview[] }>([status], listInitialInterviews)
    const coachResult = useQuery<Coach[]>('initial_interview', listCoach)

    const onAlloc = (interview: InitialInterview) => (event: React.ChangeEvent<HTMLInputElement>) => {
        let coachId: string | null = null
        if (+event.target.value > 0) {
            coachId = event.target.value
        }
        allocInitialInterviewCoach(`${interview.id}`, coachId, interview.appointment_time).then(res => {
            refetch()
        })
    }

    const onAppointmentTimeChange = (interview: InitialInterview) => (date: Date | null) => {
        allocInitialInterviewCoach(`${interview.id}`, `${interview.coach_id}`, date ? date.getTime() : null).then(res => {
            refetch()
        })

    }

    const onStatusChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setStatus(event.target.value)
    }

    return <Box>
        <Paper>
            <Box className={tableClasses.header} display="flex" alignItems="center">
                <Typography variant="h6">首次约谈任务管理</Typography>
                <TextField size="small" SelectProps={{ style: { color: '#fff' } }} select value={status} style={{ marginLeft: '24px', color: '#fff' }} onChange={onStatusChange}>
                    <MenuItem value="waitAlloc">待分配</MenuItem>
                    <MenuItem value="allocated">已分配</MenuItem>
                    <MenuItem value="allocatedCreate">已分配未完成</MenuItem>
                    <MenuItem value="all">全部</MenuItem>
                </TextField>
            </Box>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>来访者姓名</StyledTableCell>
                            <StyledTableCell align="center">来访者手机</StyledTableCell>
                            <StyledTableCell align="center">来访者微信号</StyledTableCell>
                            <StyledTableCell>任务名称</StyledTableCell>
                            <StyledTableCell>支付时间</StyledTableCell>
                            <StyledTableCell>主要咨询问题</StyledTableCell>
                            <StyledTableCell>期望时间段</StyledTableCell>
                            <StyledTableCell>负责教练</StyledTableCell>
                            <StyledTableCell>预约处理时间</StyledTableCell>
                            <StyledTableCell>任务状态</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.list.map((interview, index) => <TableRow key={interview.id}>
                            <TableCell>{interview.name}</TableCell>
                            <TableCell align="center">{interview.mobile}</TableCell>
                            <TableCell align="center">{interview.wechat}</TableCell>
                            <TableCell>首次约谈</TableCell>
                            <TableCell>{moment(interview.create_time).format('YYYY-MM-DD HH:mm')}</TableCell>
                            <TableCell>{ConsultingContentMap[interview.consulting_content]}</TableCell>
                            <TableCell>{interview.client_appointment_time}</TableCell>
                            <TableCell>
                                <TextField select value={interview.coach_id ? `${interview.coach_id}` : "0"} onChange={onAlloc(interview)}>
                                    <MenuItem value="0">未分配</MenuItem>
                                    {coachResult?.data?.map(coach => <MenuItem key={coach.user_id} value={`${coach.user_id}`}>
                                        {coach.name}
                                    </MenuItem>)}
                                </TextField>
                            </TableCell>
                            <TableCell>
                                <DateTimePicker
                                    clearable
                                    placeholder="点击设置"
                                    value={interview.appointment_time ? moment(interview.appointment_time).toDate() : null}
                                    format="yyyy-MM-dd HH:mm"
                                    onChange={onAppointmentTimeChange(interview)}
                                />
                            </TableCell>
                            <TableCell>{interview.status === 'finish' ? '已完成' : '未完成'}</TableCell>
                        </TableRow>)}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    </Box>
}
export default InitialInterview